/**
 * Escape HTML entities to prevent XSS attacks.
 * Use this when inserting user-provided data into HTML via {@html} directives.
 */
export function escapeHtml(str) {
    if (str == null) return '';
    return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
}

/**
 * Escape all string values in an object.
 * Useful for escaping i18n interpolation values.
 */
export function escapeValues(obj) {
    const escaped = {};
    for (const key in obj) {
        const value = obj[key];
        escaped[key] = typeof value === 'string' ? escapeHtml(value) : value;
    }
    return escaped;
}
